<template>
  <div class="d-flex w-100 flex-column">
    <div
      v-for="(element, index) in itemsList"
      :key="'help-category-' + index"
      class="d-flex w-100 flex-column mb-3"
    >
      <span class="text-primary font-weight-bold">
        {{ element.category.name }}
      </span>
      <div class="help-complex-items-container d-flex border rounded w-100 flex-column p-2">
        <complexItem
          v-for="(item, key) in element.changes"
          :color="element.category.color"
          :key="'help-item-' + key"
          @onChecked="({ checked }) => onItemClick(checked, element.category.id, item)"
          :data="item"
        />
        <b-button
          v-if="element && element.showMore"
          class="ml-auto p-1"
          variant="link"
          @click="() => showhide(index)"
        >
          {{ element.show ? 'Show Less' : 'Show More' }}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import complexItem from './complexItem.vue';
export default {
  components: {
    complexItem,
  },
  props: {
    options: Array,
  },
  data() {
    return {
      items: [],
      changesByCategory: {},
      itemsList: [],
    };
  },
  methods: {
    showhide(index) {
      this.itemsList = this.itemsList.map((o, key) => {
        return {
          ...o,
          ...(key === index && {
            changes: !o.show ? this.options[key].changes : this.options[key].changes.slice(0, 3),
            show: !o.show,
          }),
        };
      });
    },
    onItemClick(isChecked, categoryId, change) {
      if (isChecked) {
        this.changesByCategory = this.changesByCategory[categoryId]?.length
          ? {
              ...this.changesByCategory,
              [categoryId]: [...this.changesByCategory[categoryId], change],
            }
          : { ...this.changesByCategory, [categoryId]: [change] };

        !this.items.includes(change.value) && this.items.push(change.value);
      } else {
        const dataToCategory = this.changesByCategory[categoryId].filter(
          (_change) => _change.value !== change.value,
        );
        this.changesByCategory[categoryId] = dataToCategory;
        this.items = [...dataToCategory];
      }
    },
  },
  created() {
    this.itemsList = this.options.map((option) => {
      const isGrantherThanLimit = option.changes.length >= 4;
      return {
        ...option,
        showMore: isGrantherThanLimit,
        show: false,
        changes: option.changes.slice(0, 3),
        checked: false,
      };
    });
  },
};
</script>
<style lang="scss">
.help-complex-items-container {
  gap: 12px;
}
</style>
